import { Chain, createPublicClient, createWalletClient, http } from 'viem';
import { base, baseSepolia } from 'viem/chains';

const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production';

const baseChain: Chain = isProduction ? base : baseSepolia;

const quickNodeUrl = isProduction
  ? `https://long-polished-asphalt.base-mainnet.quiknode.pro/${process.env.NEXT_PUBLIC_QUICKNODE_API_KEY}`
  : `https://compatible-attentive-owl.base-sepolia.quiknode.pro/${process.env.NEXT_PUBLIC_QUICKNODE_API_KEY}`;

const baseQuickNodeTransport = http(quickNodeUrl);

export const BaseQuickNodeProvider = createPublicClient({
  chain: baseChain,
  transport: baseQuickNodeTransport,
});

export const BaseQuickNodeWalletProvider = createWalletClient({
  chain: baseChain,
  transport: baseQuickNodeTransport,
});
